module.exports = __webpack_public_path__ + "img/klz-logo.17d40465.svg";